import { network } from 'services/network';

import { QueryParams } from 'api/queries/getSummaryTrackedActivities.query';

const ENDPOINT = 'api/bo/getTrackedItems';

export const getTrackedItems = (params: QueryParams, endpoint = ENDPOINT) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filter,
    };
    return network.post(endpoint, payload).then((response) => {
        return response.data;
    });
};
